<template>
  <div class="orderContent" v-if="isLogined">
    <div class="title">我的订单</div>
    <div class="search">
      <select class="orderStatus" v-model="queryForm.orderType" placeholder="订单状态" >
        <option label="全部订单" />
        <option label="待付款" value="unpaid" />
        <option label="待发货" value="pay" />
        <option label="已发货" value="delivery" />
        <option label="已完成" value="finish" />
      </select>
      <label class="productName">商品名称：<input type="text" v-model="queryForm.productName" placeholder="请输入商品名称"></label>
      <label class="dealDate">
        成交日期： 
        <el-date-picker v-model="queryForm.createStartTime" suffix-icon="el-icon-date" type="date" placeholder="开始时间"></el-date-picker>
        -
        <el-date-picker v-model="queryForm.createEndTime" suffix-icon="el-icon-date" type="date" placeholder="结束时间"></el-date-picker>
      </label>
      <input class="searchBtn" type="button" value="搜索" @click="_orderList()">
    </div>
    <div class="orderList">
      <table v-for="(item,i) in orderList" :key="'order_'+i">
        <tr class="addressHead">
          <th colspan="8"><span>{{item.creationTime | formatDateTime}}</span><span class="orderCode">订单号：<a @click="orderDetail(item.id)">{{item.orderCode}}</a></span><span class="supplierName">供应商：<a  @click="consultAsk(item)">{{item.supplierName}}</a></span><img @click="_delOrder(item.id,i)" title="删除订单" src="http://img.static.knnnj.com/Default/c431046e-a858-4071-959e-70a09d70dcbb.png"></th>         
        </tr>
        <tr v-for="(good,j) in item.ordersDetials" :key="'goods_'+j">
          <td class="productImg" title="商品主图"><img @click="goodsDetails(good.productId)" :src="good.defaultImage" ></td>
          <td class="productName" title="商品名称">{{good.pName}}{{good.specName!=''&&good.specName!='0'&&good.specName!=null?"("+good.specName+")":""}}</td>
          <td class="productPrice" title="单价">￥{{Number(good.price).toFixed(2)}}</td>
          <td class="productNum" title="数量">x{{good.num}}</td>
          <td class="productTotal" title="合计" >￥{{Number(good.price*good.num).toFixed(2)}}</td>
          <td class="orderStatus" title="订单状态">
            <span v-if="!(item.ordersDetials.find((p) => p.refundStatus>0))&&j==0"> {{ item.status }}</span>
            <span v-if="good.refundStatus>0"> {{ good.refundStatusDisplay }}</span>
          </td>
          <td class="orderOperate">
            <div v-if="j==0"> 
              <input v-if="!item.isPay && item.status=='待支付'" type="button" class="orderOperateBtn" value="去付款" @click="orderPayment(item)">
              <input v-if="item.isPay && item.status=='待发货'" type="button" class="orderOperateBtn" value="申请退款" @click="orderRefund(item)">
              <input v-if="item.isPay && !item.isDelivery && item.status=='退款中'" type="button" class="orderOperateBtn" value="取消退款" @click="cancelRefund(item)">
              <input v-if="item.isPay && item.status=='已发货'" type="button" class="orderOperateBtn" value="确认收货" @click="orderConfirm(item.id)">  
              <input v-if="item.isFinish && item.status=='已完成' && item.evaluateNum==0" type="button" class="orderOperateBtn" value="评价" @click="orderEvaluate(item)">  
            </div>
            <div v-if="item.isPay && !item.isCancel && item.isDelivery && !item.isFinish &&good.num>good.refundNum">            
              <input type="button" class="orderOperateBtn" style="margin-top:8px;" value="申请退货" @click="orderReturn(item, good)">          
            </div>
            <div v-if="good.refundStatus==2||good.refundStatusDisplay=='同意退款'">            
              <input type="button" class="orderOperateBtn" style="margin-top:8px;" value="寄回商品" @click="sendBack(item, good)">           
            </div>
            <div v-if="good.refundStatus==1">           
              <input type="button" class="orderOperateBtn" style="margin-top:8px;" value="取消退货" @click="cancelReturn(good)">             
            </div>
          </td>
        </tr>
      </table>
      <img v-if="orderList.length==0"  src="http://img.static.knnnj.com/Default/a5fd662b-be92-49de-9b8a-b36575efcc1c.png">
      <el-pagination
                      v-if="!noResult&&!error"
                      @current-change="handleCurrentChange"
                      :page-size="pageSize"
                      @size-change="handleSizeChange"
                      layout="prev, pager, next, jumper"
                      :total="total">
                    </el-pagination>
    </div>
    <orderRefund ref="orderRefund" @fetch-data="_orderList"></orderRefund>
    <orderReturn ref="orderReturn" @fetch-data="_orderList"></orderReturn>
    <orderEvaluate ref="orderEvaluate" @fetch-data="_orderList"></orderEvaluate>
    <sendBack ref="sendBack" @fetch-data="_orderList"></sendBack>
    <applyInvoice ref="applyInvoice" @fetch-data="_orderList"></applyInvoice>
    <consult ref="consult" @fetch-data="_orderList"></consult>
  </div>
  <div class="orderContent1" v-else >
    <div @click="toLogin()">亲,请先登陆</div>
  </div>
</template>
<style>
@import '../../styles/order.css';
</style>
<script>
  import api from '@/api'
  import { getOrderList, finish, cancelRefund, cancelReturn, Delete } from '@/api/order'
  import YShelf from '@/components/shelf'
  import OrderRefund from './components/OrderRefund'
  import OrderReturn from './components/OrderReturn'
  import OrderEvaluate from './components/OrderEvaluate'
  import SendBack from './components/SendBack'
  import ApplyInvoice from './components/ApplyInvoice'
  import Consult from './components/Consult'
  import { getStore, setStore  } from '@/utils/storage'
  import { mapState} from 'vuex'
  export default {
    data () {
      return {
        orderList: [],
        loading: true,
        queryForm:{
            orderType: '',
            productName:'',
            createStartTime:'',
            createEndTime:'',
            maxResultCount:10,
            skipCount:0,
        },
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    computed: {
      ...mapState(['isLogined']), 
    },
    methods: {
      toLogin() {
        this.$router.push({ name: 'userLogin' })
      },
      message (m) {
        this.$message.error({
          message: m
        })
      },
      handleSizeChange (val) {
        this.pageSize = val
        this._orderList()
      },
      handleCurrentChange (val) {
        this.currentPage = val 
        this._orderList()
      },
      orderPayment (item) {
        let  addressInfo = {
          address:item.address,
          mobile:item.mobile,
          name:item.nickName
        }
        setStore('addressInfo',addressInfo)
        let cartList = []
        item.ordersDetials.forEach(e => {
          cartList.push({
            productId:e.id,
            specId:e.specId,
            settlementPrice:e.price,
            name:e.pName,
            specName:e.specName,
            num:e.num,
            defaultImage:e.defaultImage
          })
        });
        setStore('cartlist',cartList)
   
        window.open(window.location.origin + '#/order/payment?orderId=' + item.id)
      },
      goodsDetails (id) {
        window.open(window.location.origin + '#/goodsDetails?productId=' + id)
      },
      orderDetail (orderId) {
        this.$router.push({ path: 'orderDetail', query: { orderId: orderId }})
      },
      orderConfirm(id){
        let params = {
          id : id
        }
        finish(params).then(res => {
          if (res.data.success === true) {
            this._orderList()
          }else{
            this.message(res.data.error.message)
          } 
        })
      },
      orderRefund(row)
      {        
        this.$refs['orderRefund'].showRefund(row)
      },
      orderReturn(order,orderItem)
      {        
        this.$refs['orderReturn'].showReturn(order,orderItem)
      },
      orderEvaluate(row)
      {        
        this.$refs['orderEvaluate'].showEvaluate(row)
      },
      sendBack(order,orderItem)
      {        
        this.$refs['sendBack'].showSendBack(order, orderItem)
      },
      applyInvoice(order)
      {
        this.$refs['applyInvoice'].show(order)
      },
      consultAsk(order)
      {
        this.$refs['consult'].show(order)
      },
      cancelRefund(row)
      {
        this.$confirm('确定取消退款吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
        }).then((r) => {
          cancelRefund({orderId:row.id}).then(res => {
          if (res.data.success === true) {
            this.$message({ message: '取消成功', type: 'success', customClass: 'c-msg' })
            this._orderList();
          }else{ this.message(res.data.error.message) } 
         })
        })
      },
      cancelReturn(row)
      {
        this.$confirm('确定取消退货吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
        }).then((r) => {
          cancelReturn({orderItemId:row.id}).then(res => {
          if (res.data.success === true) {
            this.$message({ message: '取消成功', type: 'success', customClass: 'c-msg' })
            this._orderList();
          }else{ this.message(res.data.error.message) } 
         })
        })
      },
      async _orderList () {
        this.queryForm.maxResultCount =  this.pageSize
        this.queryForm.skipCount = (this.currentPage - 1) * this.pageSize
        await getOrderList(this.queryForm).then(res => {
          if (res.data.success === true) {
            this.orderList = res.data.result.items
            this.total = res.data.result.totalCount
            this.loading = false
          } else {
            this.orderList = []
          }
        }).catch(error => {
            this.orderList = []
        })
       
      },
      _delOrder (orderId, i) {
        this.$confirm('确定删除吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
        }).then((r) => {
        Delete({id:orderId}).then(res => {
          if (res.data.success === true) {
            this.$message({
                message: '删除成功',
                type: 'success',
                customClass: 'c-msg'
              })
            this.orderList.splice(i, 1)
          }else{
            this.message(res.data.error.message)
          } 
         })
        })
      }
    },
    created () {
      if(this.isLogined)
      {
        this._orderList()
      }else
      {
         this.toLogin()
      }
    },
    components: {
      YShelf,
      OrderRefund,
      OrderReturn,
      OrderEvaluate,
      SendBack,
      ApplyInvoice,
      Consult
    }
  }
</script>



// WEBPACK FOOTER //
// orderList.vue?d717fdc8